import { useEffect } from "react";

const useCustomBackButton = (redirectUrl = "/dashboard") => {
  useEffect(() => {
    // window.history.replaceState(null, "", redirectUrl);
  });
};

export default useCustomBackButton;
